import { createAction, props } from "@ngrx/store";
import { IStory } from "../../interfaces/IStory";
import { IStoryResponse } from "../../interfaces/IStoryResponse";

export const loadStories = createAction(
  '[Stories] Load Stories',
  props<{ projectUUID: string }>()
);

export const loadStoriesSuccess = createAction(
  '[Stories] Load Stories Success',
  props<{ stories: IStoryResponse }>()
);

export const loadStoriesFailure = createAction(
  '[Stories] Load Stories Failure',
  props<{ error: any }>()
);

export const createStory = createAction(
  '[Stories] Create Story',
  props<{ projectUUID: string; story: Omit<IStory, 'id'> }>()
);

export const createStorySuccess = createAction(
  '[Stories] Create Story Success',
  props<{ story: IStory }>()
);

export const createStoryFailure = createAction(
  '[Story] Create Story Failure',
  props<{ error: any }>()
);

export const updateStory = createAction(
  '[Story] Update Story',
  props<{ projectUUID: string; storyId: number; story: Partial<IStory> }>()
);

export const updateStorySuccess = createAction(
  '[Story] Update Story Success',
  props<{ story: IStory }>()
);

export const updateStoryFailure = createAction(
  '[Story] Update Story Failure',
  props<{ error: any }>()
);

export const deleteStory = createAction(
  '[Story] Delete Story',
  props<{ projectUUID: string; storyId: number }>()
);

export const deleteStorySuccess = createAction(
  '[Story] Delete Story Success',
  props<{ storyId: number }>()
);

export const deleteStoryFailure = createAction(
  '[Story] Delete Story Failure',
  props<{ error: any }>()
);